import { render, staticRenderFns } from "./AbnormalAudio.vue?vue&type=template&id=236994c7&scoped=true&"
import script from "./AbnormalAudio.vue?vue&type=script&lang=js&"
export * from "./AbnormalAudio.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalAudio.vue?vue&type=style&index=0&id=236994c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236994c7",
  null
  
)

export default component.exports